import type { GetMeasurementOrganizationsResponse } from '@/types/MeasurementOrganization.ts'

import { apiGet } from './ApiClient'
export async function getMeasurementOrganizations(): Promise<GetMeasurementOrganizationsResponse> {
  return await apiGet<GetMeasurementOrganizationsResponse>('/measurement-organizations')
}
